import { BuildingIcon, TargetIcon, UsersIcon } from "lucide-react";
import { SettingsSidebarGroup } from "./SettingsSidebar";

function getAvailablePaths(isRoot: boolean): string[] {
  return getSidebarGroups(isRoot).flatMap((group) => group.items.map((item) => item.path));
}

export function isPathAvailable(path: string | undefined, isRoot: boolean): boolean {
  if (!path) return false;

  const pathSegment = path.includes("/") ? path.split("/").pop() : path;

  return getAvailablePaths(isRoot).includes(pathSegment as string);
}

export function getSidebarGroups(isRoot: boolean): SettingsSidebarGroup[] {
  if (isRoot) {
    return [
      {
        label: "settings.organization",
        items: [
          { label: "settings.users", path: "users", icon: UsersIcon },
          { label: "settings.businesses", path: "businesses", icon: BuildingIcon },
          { label: "settings.budgets", path: "budget", icon: TargetIcon },
        ],
      },
    ];
  }

  // Non-root users have no settings pages, so S hides its Settings link for them.
  return [];
}
